export const SET_BILLING_COMPANY_DETAILS = 'SET_BILLING_COMPANY_DETAILS'
export const SET_BILLING_COMPANY_DETAIL = 'SET_BILLING_COMPANY_DETAIL'
export const SET_BILLING_COMPANY_DETAILS_META = 'SET_BILLING_COMPANY_DETAILS_META'
export const SET_BILLING_SERIES_POLICIES = 'SET_BILLING_SERIES_POLICIES'
export const SET_BILLING_SERIES_POLICY = 'SET_BILLING_SERIES_POLICY'
export const SET_BILLING_SERIES_POLICIES_META = 'SET_BILLING_SERIES_POLICIES_META'
export const SET_BILLING_DOCUMENT_CONFIGS = 'SET_BILLING_DOCUMENT_CONFIGS'
export const SET_BILLING_DOCUMENT_CONFIG = 'SET_BILLING_DOCUMENT_CONFIG'
export const SET_BILLING_DOCUMENT_CONFIGS_META = 'SET_BILLING_DOCUMENT_CONFIGS_META'
export const SET_BILLING_DEBETAS_DIMENSION_DETAIL = 'SET_BILLING_DEBETAS_DIMENSION_DETAIL'
export const SET_BILLING_DEBETAS_DIMENSION_DETAILS = 'SET_BILLING_DEBETAS_DIMENSION_DETAILS'
export const SET_BILLING_DEBETAS_DIMENSION_HEADER = 'SET_BILLING_DEBETAS_DIMENSION_HEADER'
export const SET_BILLING_DEBETAS_DIMENSION_HEADERS = 'SET_BILLING_DEBETAS_DIMENSION_HEADERS'
export const SET_BILLING_DEBETAS_DIMENSION_HEADER_DATA_FIELDS = 'SET_BILLING_DEBETAS_DIMENSION_HEADER_DATA_FIELDS'
export const SET_BILLING_RECORDS = 'SET_BILLING_RECORDS'
export const SET_BILLING_RECORD = 'SET_BILLING_RECORD'
export const SET_BILLING_RECORD_RELATED_ORDER = 'SET_BILLING_RECORD_RELATED_ORDER'
export const SET_BILLING_RECORDS_META = 'SET_BILLING_RECORDS_META'
export const SET_BILLING_CASH_REGISTERS = 'SET_BILLING_CASH_REGISTERS'
export const SET_BILLING_CASH_REGISTER = 'SET_BILLING_CASH_REGISTER'
export const SET_BILLING_CASH_REGISTERS_META = 'SET_BILLING_CASH_REGISTERS_META'
export const SET_BILLING_CASH_REGISTER_SERIES_POLICIES = 'SET_BILLING_CASH_REGISTER_SERIES_POLICIES'
export const SET_BILLING_ACCOUNTING_EXPORT_CONFIG = 'SET_BILLING_ACCOUNTING_EXPORT_CONFIG'
export const SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS = 'SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS'
export const SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META = 'SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META'
export const SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS = 'SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS'
export const SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META = 'SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META'
export const SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP = 'SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP'
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS'
export const SET_LOADING = 'SET_LOADING'
